export default __webpack_public_path__ + "static/media/icon_mobx.0d3b80d7.png";